import { connect } from 'react-redux';
import { makeStyles, tokens } from '@fluentui/react-components';
import { AppState } from '../../../../redux/reducers';
import { QueueDisplayScreen } from '../../../../models/Entities/Turnero';
import { ErrorType } from '../../../../models/HttpError';
import * as QueueDisplayScreenStore from '../../../../redux/middleware/Turnero/Turnero.QueueDisplayScreen.Middleware';

export interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
  defaultSectorId?: number;
  defaultSedeId?: number;
}

interface StateProps {
  list: QueueDisplayScreen[];
  isSaving: boolean;
  successAddingNewOne?: boolean;
  failOnAddingNewOne: boolean;
  error?: ErrorType;
}

interface DispatchProps {
  CreateQueueDisplayScreen: (payload: QueueDisplayScreen) => void;
  GetQueueDisplayScreenById: (id: number) => void;
  GetQueueDisplayScreens: () => void;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState): StateProps => ({
  list: state.Turnero?.QueueDisplayScreen?.list || [],
  isSaving: state.Turnero?.QueueDisplayScreen?.isAddingNewOne || false,
  successAddingNewOne: state.Turnero?.QueueDisplayScreen?.successAddingNewOne,
  failOnAddingNewOne: state.Turnero?.QueueDisplayScreen?.failOnAddingNewOne || false,
  error: state.Turnero?.QueueDisplayScreen?.error,
});

export const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  CreateQueueDisplayScreen: (payload: QueueDisplayScreen) => dispatch(QueueDisplayScreenStore.actionCreators.CreateQueueDisplayScreen(payload)),
  GetQueueDisplayScreenById: (id: number) => dispatch(QueueDisplayScreenStore.actionCreators.GetQueueDisplayScreenById(id)),
  GetQueueDisplayScreens: () => dispatch(QueueDisplayScreenStore.actionCreators.GetQueueDisplayScreens()),
});

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    minWidth: '22rem',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
});

export const connector = connect<StateProps, DispatchProps, OwnProps, AppState>(mapStateToProps, mapDispatchToProps);
